import { useEffect } from "react"

export declare type InputProps = {
    chartData: []
}


export const StatusChart = ({ chartData }: InputProps) => {



    return (
        <div className="w-full h-full flex flex-col justify-between">
            <span className=" text-sm text-center">وضعیت ۷ روز گذشته</span>
            <div className="w-full h-[100px]  flex items-end justify-center">
                {chartData?.map((item: any, index: number) =>
                    <div key={index} className="flex mx-1 items-end relative h-full ">
                        <div className=" group">
                            <div className="bg-red-600 w-[70px] h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">{item.rollcalls } تردد</div>
                            <div className="w-[5px] bg-red-600  max-h-[100px] " style={{ 'height': item.rollcalls != 0 ? 20 * item.rollcalls : '5px' }} />
                        </div>
                        <div className=" group">
                            <div className="bg-dayan-orange-50 w-[70px] h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">{ item.reasons_count} تاخیر</div>
                            <div className="w-[5px] bg-dayan-orange-50  max-h-[100px]" style={{ 'height': item.reasons_count != 0 ? 20 * item.reasons_count : '5px' }} />
                        </div>
                        <div className=" group">
                            <div className="bg-[#ffbf00] w-[70px] h-[20px] px-1 absolute text-dayan-gray-100 flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">{item.overtimes_count  } اضافه کار</div>
                            <div className="w-[5px] bg-[#ffbf00]  max-h-[100px]" style={{ 'height': item.overtimes_count != 0 ?  20 * item.overtimes_count : '5px' }} />
                        </div>

                    </div>
                )}
            </div>
        </div>
    );
}